import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { ILink } from '../caremap/WithLinks';

export interface IChatMessage {
    role: 'user' | 'assistant';
    content: string;
    createdAt: string;
}

export interface IChat {
    userId: string;
    chatId: string;
    messages: IChatMessage[];
    createdAt: string;
    lastMessageAt: string;
    links: {
        self: ILink;
    };
}

export interface ICareMapKey {
    careMapId: string;
    userId: string;
}

export class BeeChatClient {
    static inject = () => [APIClient];

    constructor(private apiClient: APIClient) {}

    getChats = async (chatsUrl: string): Promise<IChat[]> => {
        return await this.apiClient.get({ href: chatsUrl });
    };

    startNewChat = async (params: {
        chatsUrl: string;
        message: string;
        careMapKey?: ICareMapKey;
    }): Promise<IChat> => {
        const { chatsUrl, message, careMapKey } = params;
        return await this.apiClient.post({ href: chatsUrl }, { message, careMapKey });
    };

    continueChat = async (params: {
        chat: IChat;
        message: string;
        careMapKey?: ICareMapKey;
    }): Promise<IChat> => {
        const { chat, message, careMapKey } = params;
        return await this.apiClient.post(chat, { message, careMapKey });
    };
}
